"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapByName = exports.die = exports.bulkInvoke = exports.invokeAsync = exports.invoke = void 0;
const jquery_1 = __importDefault(require("jquery"));
const underscore_1 = __importDefault(require("underscore"));
/**
 * Invokes the given callback with the given arguments
 *
 * @param {Function} callback
 * @param {Array} [args]
 * @param {Object} [scope]
 *
 * @returns {Mixed}
 */
function invoke(callback, args, scope) {
    if (!(0, underscore_1.default)(callback).isFunction()) {
        return null;
    }
    return callback.apply(scope, args || []);
}
exports.invoke = invoke;
/**
 * This is nearly the same as invoke, except that it assumes that the callback returns a promise. The callback doesn't
 * HAVE to return a promise, but it CAN, and if it doesn't, then we provide a promise
 *
 * @param {Function} callback
 * @param {Array} [args]
 * @param {Object} [scope]
 *
 * @returns {$.Deferred}
 */
function invokeAsync(callback, args, scope) {
    if (!(0, underscore_1.default)(callback).isFunction()) {
        return new jquery_1.default.Deferred().resolve();
    }
    let promiseFromCallback = callback.apply(scope, args || []);
    // If there was not a promise returned from the prefetch callback, then create a dummy promise and resolve it
    if (!promiseFromCallback) {
        promiseFromCallback = new jquery_1.default.Deferred().resolve();
    }
    return promiseFromCallback;
}
exports.invokeAsync = invokeAsync;
/**
 * Invokes all the given callbacks with the given arguments
 *
 * @param {Function[]} callbacks
 * @param {Array} [args]
 */
function bulkInvoke(callbacks, args) {
    callbacks.forEach((callback) => invoke(callback, args));
}
exports.bulkInvoke = bulkInvoke;
/**
 * Throws an uncaught error in an attempt to stop JS execution
 */
function die() {
    throw new Error('Aborting JavaScript execution');
}
exports.die = die;
/**
 * Call the method on a list of objects
 *
 * @param {object|array} list
 * @param {string} methodName
 * @returns {Array}
 */
function mapByName(list, methodName) {
    return underscore_1.default.map(list, (item) => item[methodName].call(item));
}
exports.mapByName = mapByName;
